/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coins_Pack_ChestInputs */

const en_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chest of Coins`)
};

const ar_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صندوق عملات`)
};

const de_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Truhe Münzen`)
};

const es_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cofre de monedas`)
};

const fr_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un coffre de Pièces`)
};

const it_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baule di Monete`)
};

const ja_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`宝箱一杯のコイン`)
};

const ko_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코인 한 상자`)
};

const pt_br_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baú de moedas`)
};

const ru_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сундук монет`)
};

const th_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เหรียญหนึ่งหีบ`)
};

const tr_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir Sandık Jeton`)
};

const zh_cn_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一大箱金币`)
};

const zh_tw_coins_pack_chest = /** @type {(inputs: Coins_Pack_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一大箱金幣`)
};

/**
* | output |
* | --- |
* | "Chest of Coins" |
*
* @param {Coins_Pack_ChestInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const coins_pack_chest = /** @type {((inputs?: Coins_Pack_ChestInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coins_Pack_ChestInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coins_pack_chest(inputs)
	if (locale === "ar") return ar_coins_pack_chest(inputs)
	if (locale === "de") return de_coins_pack_chest(inputs)
	if (locale === "es") return es_coins_pack_chest(inputs)
	if (locale === "fr") return fr_coins_pack_chest(inputs)
	if (locale === "it") return it_coins_pack_chest(inputs)
	if (locale === "ja") return ja_coins_pack_chest(inputs)
	if (locale === "ko") return ko_coins_pack_chest(inputs)
	if (locale === "pt_br") return pt_br_coins_pack_chest(inputs)
	if (locale === "ru") return ru_coins_pack_chest(inputs)
	if (locale === "th") return th_coins_pack_chest(inputs)
	if (locale === "tr") return tr_coins_pack_chest(inputs)
	if (locale === "zh_cn") return zh_cn_coins_pack_chest(inputs)
	return zh_tw_coins_pack_chest(inputs)
});